import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

/*
export class AppointmentResourceSettingsService extends EntityCollectionServiceBase<AppointmentResources> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('AppointmentResources', serviceElementsFactory);
    }
}
*/

export class AppointmentResourceSettingsService {
    constructor(private httpClient: HttpClient
    ) {
    }

    getAppointmentResources(userid): Observable<Array<any>> {
        const url = userid === null || userid === undefined ? 'servlets/appointmentresources/' :
            `servlets/appointmentresources/?userid=${userid}`;

        return this.httpClient
        .get(url, {observe: 'body'})
        .pipe(
            map((response: any) => response)
        );
    }

    getEstimatedAppointmentsAffected(resourceId, strategyId): Observable<any>  {
        return this.httpClient
            .get(`servlets/appointmentresources/${resourceId}/${strategyId}/estimated/`);
    }

    saveAppointmentResourceStrategyMapping(resourceId, strategyId): Observable<any>  {

        return this.httpClient
            .post(`servlets/appointmentresources/${resourceId}/${strategyId}/`, {});
    }

    getAppointmentResourcesAndResources(userid): Observable<Array<any>> {
        const url = userid === null || userid === undefined ? 'servlets/appointmentresources/resources/' :
            `servlets/appointmentresources/resources/?userid=${userid}`;

        return this.httpClient
            .get(url, {observe: 'body'})
            .pipe(
                map((response: any) => response)
            );
    }
}
